import React from "react";

interface IntimoProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconIntimo: React.FC<IntimoProps> = ({ className, width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
    <g mask="url(#a)">
      <path
        d="M17.4 21.501q.975 0 1.85.35a5.1 5.1 0 0 1 1.6 1.025l9.55 9.125h.6q.424 0 .712-.287A.97.97 0 0 0 32 31a2.6 2.6 0 0 0-.038-.425q-.037-.225-.262-.45l-4.575-4.575-1.775-5.35-1.85.45a1.9 1.9 0 0 1-1.725-.35Q21 19.7 21 18.725v-2.1l-.7-.35-3.85 5.15q-.025.026-.025.038t-.025.037zm0 2h-1.15a1.6 1.6 0 0 0 .45.6l8.1 7.375q.275.275.625.4t.725.125h1.35l-8.025-7.675a2.7 2.7 0 0 0-.963-.625q-.537-.2-1.112-.2m8.75 10.5q-.75 0-1.425-.275a4.5 4.5 0 0 1-1.25-.775l-8.125-7.375q-1.15-1.05-1.287-2.575-.138-1.526.787-2.775l3.85-5.15a2 2 0 0 1 1.137-.763q.714-.187 1.363.163l.7.35q.524.274.813.75.287.476.287 1.05v2.1l1.85-.475q.75-.2 1.45.188.7.387.95 1.112l1.625 4.9 4.25 4.25q.5.5.688 1.075T34 31.001q0 1.25-.875 2.125a2.9 2.9 0 0 1-2.125.875z"
        fill="#C2282B"
      />
    </g>
  </svg>
);
export default IconIntimo;
